import { defineStore } from 'pinia'
import { ref, Ref } from 'vue'
import { auth0 } from 'Common/plugins/auth0'
import { api_logout } from 'API/definitions/iris/authentication'

export const useUserStore = defineStore('UserStore', () => {
  const email: Ref<string> = ref('')
  const name: Ref<string> = ref('')

  // log out the user and reset the state
  const logout = async (returnTo: string = window.location.origin) => {
    resetState()
    await api_logout()


    await auth0.logout({
      logoutParams: {
        returnTo,
      },
    })
  }

  // reset the state variables to the original values
  const resetState = () => {
    email.value = ''
    name.value = ''
  }

  // set the user data based on the given user object
  const setUserData = () => {
    if (!auth0.user) {
      return
    }

    email.value = auth0.user.value.email
    name.value = auth0.user.value.name
  }

  return {
    email,
    name,
    isAuthenticated: auth0.isAuthenticated,
    logout,
    resetState,
    setUserData,
  }
})
